import { render } from "./GetBookCountView.vue?vue&type=template&id=b4fe4604"
import script from "./GetBookCountView.vue?vue&type=script&lang=js"
export * from "./GetBookCountView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__